<div class="modal fade" id="modalInventoryManagement" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">

            <!-- HEADER -->
            <div class="modal-header">
                <div class="d-flex flex-column">
                    <h5 class="modal-title mb-1">
                        <i class="fa-solid fa-boxes-stacked me-2"></i>
                        Gestión de Inventario y Cupos
                    </h5>

                    <div class="small text-muted d-flex flex-wrap gap-3">
                        <span>
                            <i class="fa-solid fa-tag me-1"></i>
                            <strong>Ítem:</strong> {{ header?.title }}
                        </span>

                        <span>
                            <i class="fa-solid fa-code-branch me-1"></i>
                            <strong>Versión:</strong> #{{ header?.versionNumber }}
                        </span>

                        <span>
                            <i class="fa-solid fa-toggle-on me-1"></i>
                            <strong>Tipo:</strong>
                            <span class="badge rounded-pill"
                                [ngClass]="header?.resourceType === 'Inventory' ? 'text-bg-primary' : 'text-bg-success'">
                                {{ header?.resourceType === 'Inventory' ? 'Inventario' : 'Cupos' }}
                            </span>
                        </span>
                    </div>
                </div>

                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>

            <!-- BODY -->
            <div class="modal-body">

                <!-- KPIs -->
                <div class="row g-3 mb-4">
                    <div class="col-md-4">
                        <div class="card kpi-card kpi-primary">
                            <div class="card-body text-center">
                                <div class="kpi-label">Total / Capacidad</div>
                                <div class="kpi-value">{{ kpis?.stockTotal || kpis?.totalSeats }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="card kpi-card kpi-warning">
                            <div class="card-body text-center">
                                <div class="kpi-label">Reservado (TTL)</div>
                                <div class="kpi-value">{{ kpis?.reservedTTL || kpis?.reservedSeatsTTL }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="card kpi-card kpi-success">
                            <div class="card-body text-center">
                                <div class="kpi-label">Disponible</div>
                                <div class="kpi-value">{{ kpis?.availableStock || kpis?.availableSeats }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- AJUSTE MANUAL -->
                <div class="card mb-4">
                    <div class="card-header fw-semibold">
                        <i class="fa-solid fa-sliders me-2"></i> Ajuste Manual
                    </div>

                    <div class="card-body">
                        <form [formGroup]="adjustmentForm" (ngSubmit)="registerAdjustment()">

                            <!-- Inputs -->
                            <div class="row g-3">

                                <!-- Tipo de ajuste -->
                                <div class="col-12 col-md-3">
                                    <label class="form-label fw-semibold">Tipo de ajuste</label>
                                    <select class="form-select" formControlName="movementTypeId">
                                        <option value="1">Entrada</option>
                                        <option value="2">Salida</option>
                                    </select>
                                </div>

                                <!-- Cantidad -->
                                <div class="col-12 col-md-3">
                                    <label class="form-label fw-semibold">Cantidad</label>
                                    <input type="number" min="1" class="form-control" formControlName="quantity"
                                        placeholder="Ej. 10" />

                                    <div class="text-danger small mt-1"
                                        *ngIf="adjustmentForm.get('quantity')?.invalid && adjustmentForm.touched">
                                        Cantidad obligatoria y mayor a 0
                                    </div>
                                </div>

                                <!-- Motivo (más grande) -->
                                <div class="col-12 col-md-6">
                                    <label class="form-label fw-semibold">Motivo del ajuste</label>
                                    <textarea rows="2" class="form-control" formControlName="reason"
                                        placeholder="Ej. Corrección de inventario, ajuste administrativo, etc.">
                                     </textarea>

                                    <div class="text-danger small mt-1"
                                        *ngIf="adjustmentForm.get('reason')?.invalid && adjustmentForm.touched">
                                        Motivo obligatorio (mín. 3 caracteres, máx. 250 caracteres)
                                    </div>
                                </div>

                            </div>

                            <!-- Botón separado -->
                            <div class="d-flex justify-content-end mt-4">
                                <button class="btn btn-primary px-4" type="submit"
                                    [disabled]="adjustmentForm.invalid || savingAdjustment()">

                                    <ng-container *ngIf="!savingAdjustment(); else savingTpl">
                                        <i class="fa-solid fa-plus me-1"></i>
                                        Registrar ajuste
                                    </ng-container>

                                    <ng-template #savingTpl>
                                        <span class="spinner-border spinner-border-sm me-2"></span>
                                        Guardando…
                                    </ng-template>

                                </button>
                            </div>

                        </form>

                    </div>
                </div>

                <!-- TABS -->
                <ul class="nav nav-tabs mb-3">
                    <li class="nav-item">
                        <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#movements">
                            Historial de Movimientos
                        </button>
                    </li>
                    <li class="nav-item">
                        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#reservations">
                            Reservas Activas (TTL)
                        </button>
                    </li>
                    <li class="nav-item">
                        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#config">
                            Configuración
                        </button>
                    </li>
                </ul>

                <div class="tab-content">

                    <!-- MOVIMIENTOS -->
                    <div class="tab-pane fade show active" id="movements">
                        <div class="table-responsive">
                            <table class="table table-theme align-middle">
                                <thead>
                                    <tr>
                                        <th>Fecha</th>
                                        <th>Tipo</th>
                                        <th>Cantidad</th>
                                        <th>Motivo</th>
                                        <th>Usuario</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngIf="!movementsLoading() && movements.length === 0">
                                        <td colspan="5" class="text-center py-4">
                                            <i class="fa-solid fa-info-circle me-2"></i>
                                            No se encontraron movimientos.
                                        </td>
                                    </tr>

                                    <tr *ngFor="let m of movements">
                                        <td>{{ m.fecha | date:'dd/MM/yyyy hh:mm a' }}</td>
                                        <td><span>{{ m.tipo }}</span></td>
                                        <td>{{ m.cantidad }}</td>
                                        <td>{{ m.motivo }}</td>
                                        <td>{{ m.usuario || 'Sistema' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="mt-3" *ngIf="movementsTotalItems() > 0">
                            <app-pagination [page]="movementsPage()" [pageSize]="movementsPageSize()"
                                [totalItems]="movementsTotalItems()" (pageChange)="onMovementsPageChange($event)"
                                (pageSizeChange)="onMovementsPageSizeChange($event)">
                            </app-pagination>
                        </div>
                    </div>


                    <!-- RESERVAS -->
                    <div class="tab-pane fade" id="reservations">

                        <div class="row g-3 align-items-end mb-3">
                            <div class="col-12 col-md-4">
                                <label class="form-label">Buscar</label>
                                <input class="form-control" type="text" [(ngModel)]="reservationsFilterValue"
                                    placeholder="Correo, nombre o código..." />
                            </div>

                            <div class="col-12 col-md-3">
                                <label class="form-label">Filtrar por</label>
                                <select class="form-select" [(ngModel)]="reservationsFilterKey">
                                    <option value="">Seleccione un filtro</option>
                                    <option value="userEmail">Correo</option>
                                    <option value="userName">Nombre</option>
                                    <option value="code">Código</option>
                                </select>
                            </div>

                            <div class="col-12 col-md-5 d-flex justify-content-end gap-2">
                                <button type="button" class="btn btn-primary" (click)="applyReservationsFilters()">
                                    <i class="fa-solid fa-magnifying-glass me-2"></i> Aplicar
                                </button>

                                <button type="button" class="btn btn-outline-secondary"
                                    (click)="clearReservationsFilters()">
                                    <i class="fa-solid fa-eraser me-2"></i> Limpiar
                                </button>
                            </div>
                        </div>

                        <div class="table-responsive">
                            <table class="table table-theme align-middle">
                                <thead>
                                    <tr>
                                        <th>Usuario</th>
                                        <th>Cantidad</th>
                                        <th>Creada</th>
                                        <th>Expira</th>
                                        <th>Link de Pago</th>
                                        <th class="text-center">Acciones</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr *ngIf="!reservationsLoading() && reservations.length === 0">
                                        <td colspan="5" class="text-center py-4">
                                            <i class="fa-solid fa-info-circle me-2"></i>
                                            No hay reservas activas
                                        </td>
                                    </tr>

                                    <tr *ngFor="let r of reservations">
                                        <td>
                                            <div class="fw-semibold">{{ r.userName }}</div>
                                            <div class="small text-muted">{{ r.userEmail }}</div>
                                        </td>

                                        <td class="text-center">{{ r.quantity }}</td>

                                        <td>{{ r.createdAt | date:'dd/MM/yyyy hh:mm a' }}</td>

                                        <td>
                                            <span class="badge text-bg-warning">
                                                {{ r.expiresAt | date:'dd/MM/yyyy hh:mm a' }}
                                            </span>
                                        </td>

                                        <td>
                                            <a class="fw-semibold text-primary text-decoration-none" target="_blank"
                                                [href]="'/pay/' + r.paymentCode">
                                                /pay/{{ r.paymentCode }}
                                            </a>
                                        </td>

                                        <td class="text-center">
                                            <button class="btn btn-sm btn-outline-danger" (click)="release(r)">
                                                <i class="fa-solid fa-unlock me-1"></i>
                                                Liberar
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <app-pagination *ngIf="reservationsTotalItems() > 0" [page]="reservationsPage()"
                            [pageSize]="reservationsPageSize()" [totalItems]="reservationsTotalItems()"
                            (pageChange)="onReservationsPageChange($event)"
                            (pageSizeChange)="onReservationsPageSizeChange($event)">
                        </app-pagination>
                    </div>


                    <!-- CONFIG -->
                    <div class="tab-pane fade" id="config">
                        <div class="row g-3">

                            <!-- Inventario -->
                            <div class="col-12 col-lg-6">
                                <div class="card h-100">
                                    <div class="card-header fw-semibold">
                                        <i class="fa-solid fa-boxes-stacked me-2"></i> Inventario
                                    </div>
                                    <div class="card-body">

                                        <div class="d-flex justify-content-between align-items-center mb-3">
                                            <div class="text-muted">Inventario habilitado</div>
                                            <span class="badge rounded-pill"
                                                [ngClass]="config?.inventoryEnabled ? 'text-bg-success' : 'text-bg-secondary'">
                                                {{ config?.inventoryEnabled ? 'Sí' : 'No' }}
                                            </span>
                                        </div>

                                        <div class="d-flex justify-content-between align-items-center mb-3">
                                            <div class="text-muted">Stock inicial</div>
                                            <div class="fw-semibold">
                                                {{ config?.initialStock ?? '—' }}
                                            </div>
                                        </div>

                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="text-muted">Permitir oversell</div>
                                            <span class="badge rounded-pill"
                                                [ngClass]="config?.allowOversell ? 'text-bg-warning' : 'text-bg-light'">
                                                {{ config?.allowOversell ? 'Sí' : 'No' }}
                                            </span>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <!-- Cupos -->
                            <div class="col-12 col-lg-6">
                                <div class="card h-100">
                                    <div class="card-header fw-semibold">
                                        <i class="fa-solid fa-users me-2"></i> Cupos
                                    </div>
                                    <div class="card-body">

                                        <div class="d-flex justify-content-between align-items-center mb-3">
                                            <div class="text-muted">Cupos habilitados</div>
                                            <span class="badge rounded-pill"
                                                [ngClass]="config?.seatsEnabled ? 'text-bg-success' : 'text-bg-secondary'">
                                                {{ config?.seatsEnabled ? 'Sí' : 'No' }}
                                            </span>
                                        </div>

                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="text-muted">Total de cupos</div>
                                            <div class="fw-semibold">
                                                {{ config?.totalSeats ?? '—' }}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <!-- Reglas / TTL / Pago -->
                            <div class="col-12">
                                <div class="card">
                                    <div class="card-header fw-semibold">
                                        <i class="fa-solid fa-gear me-2"></i> Reglas y Ventanas
                                    </div>

                                    <div class="card-body">
                                        <div class="row g-3">

                                            <div class="col-12 col-md-4">
                                                <div class="config-tile">
                                                    <div class="text-muted small">Hold TTL (min)</div>
                                                    <div class="fw-semibold fs-5">{{ config?.holdTTLMinutes ?? '—' }}
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-12 col-md-4">
                                                <div class="config-tile">
                                                    <div class="text-muted small">Pre-aprobación requerida</div>
                                                    <div>
                                                        <span class="badge rounded-pill"
                                                            [ngClass]="config?.preApprovalRequired ? 'text-bg-primary' : 'text-bg-light'">
                                                            {{ config?.preApprovalRequired ? 'Sí' : 'No' }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-12 col-md-4">
                                                <div class="config-tile">
                                                    <div class="text-muted small">Ventana de pago (min)</div>
                                                    <div class="fw-semibold fs-5">{{ config?.paymentWindowMinutes ?? '—'
                                                        }}</div>
                                                </div>
                                            </div>

                                        </div>

                                        <div class="alert alert-secondary mt-3 mb-0" *ngIf="config">
                                            <i class="fa-solid fa-circle-info me-2"></i>
                                            Estos valores aplican a la versión seleccionada y se usan para calcular
                                            reservas TTL, disponibilidad y reglas de aprobación.
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <!-- FOOTER -->
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">
                    Cerrar
                </button>
            </div>

        </div>
    </div>
</div>